import {hideLinks, displayLinks} from './FOO01-footer-links-utils';
import {respoBreakPoints} from "../../../common/common";

export default {
	data() {
		return {
			isOpen: false,
			isAllLinksOpen: false,
			numberOfHiddenLinks: 0
		}
	},
	methods: {
		toggleOpen() {
			this.isOpen = !this.isOpen;
		},
		toggleHide() {
			if (this.isAllLinksOpen) {
				hideLinks(this);
				this.isAllLinksOpen = false;
			} else {
				displayLinks(this);
				this.isAllLinksOpen = true;
			}
		},
		switchMobile() {
			if (this.$resize && this.$mq.below(respoBreakPoints.tablet)) {
				this.isAllLinksOpen = false;
				this.toggleHide();
			} else {
				this.isAllLinksOpen = true;
				this.toggleHide()
			}
		}
	},
	mounted() {
		// init links open state
		this.switchMobile();
	},
	props: ['numberOfDisplayedLinks', 'listitemClassName', 'hiddenClassName']
}



// WEBPACK FOOTER //
// ../source/modules/FOO01-footer/FOO01-footer-links/FOO01-footer-links.js